import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/ui";

export function Blog({ news }) {
  const posts = news.filter((n) => (n.section || "newsroom") === "blog").slice(0, 6);
  return (
    <section id="blog" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal><Eyebrow>The Fab Lab</Eyebrow></Reveal>
          <Reveal delay={0.05}><h2 className="mt-4 font-heading text-4xl md:text-6xl text-ink">Inside The Fab Lab</h2></Reveal>
          <Reveal delay={0.1}><p className="mt-5 font-accent text-2xl md:text-3xl italic text-bronze">Track tips, recipes, recovery, and the real journey. A taste of what's inside.</p></Reveal>
        </div>
        {posts.length === 0 ? (
          <div className="mt-12 rounded-[2rem] border border-dashed border-champagne/50 bg-blush/5 p-12 md:p-16 text-center max-w-2xl mx-auto" data-testid="blog-empty-state">
            <Sparkles className="mx-auto text-bronze" size={26} />
            <p className="mt-4 font-heading text-2xl md:text-3xl text-ink">More Updates Coming Soon</p>
            <p className="mt-3 font-body text-sm md:text-base text-ink/60 leading-relaxed">Leah is putting together the first stories for The Fab Lab. Join the community below to be first to read them when they publish.</p>
          </div>
        ) : (
          <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((a, i) => (
              <Reveal key={a.id} delay={i * 0.06}>
                <Link to={`/news/${a.id}`} data-testid={`blog-card-${a.id}`} className="group block h-full rounded-[1.5rem] overflow-hidden bg-ivory border border-champagne/30 hover:-translate-y-1 transition-transform">
                  {a.image_url && <div className="aspect-[16/10] overflow-hidden"><img src={a.image_url} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" /></div>}
                  <div className="p-6">
                    <p className="label-eyebrow">{a.date}</p>
                    <p className="mt-2 font-heading text-lg text-ink leading-snug group-hover:text-bronze transition-colors line-clamp-2">{a.title}</p>
                    <p className="mt-2 font-body text-sm text-ink/60 line-clamp-3">{a.excerpt}</p>
                    <span className="mt-4 inline-flex items-center gap-1 font-body text-xs uppercase tracking-wide text-bronze">Read more <ArrowUpRight size={13} /></span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
